module.exports = __webpack_public_path__ + "static/media/health.d97bf492.png";